<ng-template #tooluploadDialogTemplate>
    <div *ngIf="!vnaUploadExternalData.type" class="vna-dilaog-container">
        <toolupload-form [vnaUploadExternalData]="vnaUploadExternalData"></toolupload-form>
        <div class="button-container-vna-dialog">
            <button mat-button mat-dialog-close
                    color="primary"
                    style="font-size:1em; margin:3px"
                    type="button"
                    (click)="closeModal()">
                <p style="margin:0" translate>Close</p>
            </button>
        </div>
    </div>
    <div *ngIf="vnaUploadExternalData.type" class="vna-dilaog-dicom-container">
        <dicom-landing-page [patientDetails]="patientDetails" [originPage]="vnaUploadExternalData.from"></dicom-landing-page>
        <div class="button-dicom-container-vna-dialog">
            <button mat-button mat-dialog-close id="close-dicom"
                    color="primary"
                    style="font-size:1em; margin:3px"
                    type="button"
                    (click)="closeModal()">
                <p style="margin:0" translate>Close</p>
            </button>
        </div>
    </div>
</ng-template>

